import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LiveNFT from "./LiveNFT/LiveNFT";
import UpcomingNFT from "./UpcomingNFT/UpcomingNFT";
const MobileNFT = () => {
  const [loading, setLoading] = useState(true);
  const [messageData, setMessageData] = useState([]);

  useEffect(() => {
    fetch(`https://api.wlfmobile.com/api/user/nft/message/view`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setMessageData(data?.data);
        setLoading(false);
      });
  }, []);

  const [handleShow, setHandleShow] = useState("Live");

  const MarketShowHandle = (data) => {
    setHandleShow(data);
  };

  if (loading) {
    return;
  }

  return (
    <>
      <div className="user-mobile-market market-area-sw mobile-market-view new-coin-area">
        <div className="  mobile-view">
          <div className="container-fluid">
            <div>
              {messageData?.title && (
                <div className="deposit-warning mb-3">
                  <small>
                    {(messageData?.title).slice(0, 80)}
                    {(messageData?.title).length >= 80 && "....."}
                  </small>
                  <br />
                  <Link
                    className="message-read-more-href"
                    to="/user/nft/message"
                    aria-expanded="false"
                    aria-controls="collapseSummary"
                  >
                    + Read More
                  </Link>
                </div>
              )}
            </div>

            <div
              className="d-flex justify-content-evenly align-items-center new-coin-live-upcoming-btn-area"
              style={{ gap: "10px", width: "100%" }}
            >
              <div className="flex-fill">
                <button
                  className={handleShow === "Live" ? "active" : "tab-button"}
                  onClick={() => MarketShowHandle("Live")}
                >
                  Live NFT
                </button>
              </div>

              <div className="flex-fill">
                <button
                  className={
                    handleShow === "Upcoming" ? "active" : "tab-button"
                  }
                  onClick={() => MarketShowHandle("Upcoming")}
                >
                  Upcoming NFT
                </button>
              </div>
            </div>
            {handleShow === "Live" && <LiveNFT></LiveNFT>}
            {handleShow === "Upcoming" && <UpcomingNFT></UpcomingNFT>}
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileNFT;
